import { useState } from "react";
import { Upload as UploadIcon, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export function FileUpload({ accept, label, onUploaded, testId }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/files/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUploaded?.(data);
      toast.success("Uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <label
      data-testid={testId}
      className="cursor-pointer inline-flex items-center gap-2 border hairline hover:border-[#FF3B30] px-4 py-3 tick-label transition-colors"
    >
      {busy ? <Loader2 size={14} className="animate-spin" /> : <UploadIcon size={14} />}
      <span>{label || "Upload"}</span>
      <input type="file" accept={accept} className="hidden" onChange={handle} disabled={busy} />
    </label>
  );
}
